import { IMAGE_SOURCES } from 'Pods/ThreeDStudio/Services/Constants/imageSources'
import { IMAGE_ACTION } from 'Pods/ThreeDStudio/Store/constants'

// Old model ids from runs stored before the Sep-2026 rename. Kept so that imageActionOf
// still classifies historical generator_runs rows. New ids win on any collision.
const LEGACY_MODEL_ID_ACTIONS = {
  'flux-text-to-image-pro': IMAGE_ACTION.TEXT_TO_IMAGE,
  'flux-similar-image-pro': IMAGE_ACTION.SIMILAR_TO,
  'flux-image-edit-pro': IMAGE_ACTION.IMAGE_EDIT,
  'flux-multi-image-edit-pro': IMAGE_ACTION.MULTI_IMAGE_EDIT,
  'flux-masked-edit-pro': IMAGE_ACTION.INPAINT,
  'nano-banana-text-to-image-lite': IMAGE_ACTION.TEXT_TO_IMAGE,
  'nano-banana-similar-image-lite': IMAGE_ACTION.SIMILAR_TO,
  'nano-banana-image-edit-lite': IMAGE_ACTION.IMAGE_EDIT,
  'nano-banana-multi-image-edit-lite': IMAGE_ACTION.MULTI_IMAGE_EDIT,
  'nano-banana-masked-edit-lite': IMAGE_ACTION.INPAINT,
}

// Reverse lookup across every provider, so a run is classified by what it did rather than
// by which provider ran it - the backend is free to answer the same action with either.
const ACTION_BY_MODEL_ID = {
  ...LEGACY_MODEL_ID_ACTIONS,
  ...Object.fromEntries(IMAGE_SOURCES.map(schema => [schema.model_id, schema.action])),
}

/**
 * The schema an image run for the action is built from: the picked provider's, or - with
 * no provider, or one that lacks the action - the first schema offering it, since every
 * provider shares the action's canonical keys and the backend ranks them itself. A caller
 * locks the run to a provider only when the schema's provider is the one picked.
 * @param {string} action - One of IMAGE_ACTION
 * @param {string} [provider] - PROVIDER.FLUX or PROVIDER.NANO_BANANA when the user picked one
 * @returns {Object|undefined} The IMAGE_SOURCES entry, or undefined for an unknown action
 */
export const imageSchemaFor = (action, provider = undefined) => (
  IMAGE_SOURCES.find(schema => schema.action === action && schema.provider === provider)
  ?? IMAGE_SOURCES.find(schema => schema.action === action)
)

/**
 * The image action a stored run performed, whichever provider produced it.
 * @param {string|undefined} providerModelId
 * @returns {string|undefined} One of IMAGE_ACTION, or undefined for an unknown model
 */
export const imageActionOf = providerModelId => ACTION_BY_MODEL_ID[providerModelId]
